export function toInputValue(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  // yyyy-MM-ddTHH:mm
  const pad = (n: number) => String(n).padStart(2, "0");
  const v = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return v;
}

export function fromInputValue(v: string): string | null {
  const s = String(v || "").trim();
  if (!s) return null;
  // браузер даёт локальное время; сохраняем как ISO
  const d = new Date(s);
  return isNaN(+d) ? null : d.toISOString();
}

export function isNowBetween(startIso: string | null, endIso: string | null): boolean {
  if (!startIso || !endIso) return false;
  const now = Date.now();
  return now >= +new Date(startIso) && now <= +new Date(endIso);
}